import React from 'react';

import SimpleContainer from '../containers/simplecontainer/SimpleContainer';
import CategoryContainer from '../containers/categorycontainer/CategoryContainer';
import LinkList from '../components/linklist/LinkList';

import backgroundImage from '../media/our-story.jpeg';
import nazkaLogo from '../media/logos/nazka-logo.png';
import esaLogo from '../media/logos/esa-logo.gif';

import 'bootstrap/dist/css/bootstrap.css';

import { PageText, Categories } from '../input-text/en/ourstory_page';

class OurStory extends React.Component {
  constructor(props) {
    super(props);
    Categories._2.subcategories[0].logoBanners[0].logoImg = nazkaLogo;
    Categories._2.subcategories[1].logoBanners[0].logoImg = esaLogo;
  }

  render(){
    return (
      <div>
        <SimpleContainer color='dark' containerClass='header-container padded-container' backgroundImage={backgroundImage}>
          <div className='col-sm-offset-4 col-sm-8 header-info'>
            <h1>{PageText._1}</h1>
            <p>{PageText._2}</p>
          </div>
        </SimpleContainer>
        <CategoryContainer cols='1' category={ Categories._1 } />
        <CategoryContainer cols='1' category={ Categories._2 } />
        <div className="visible-xs-block">
          <CategoryContainer cols='1' category={ Categories._3 } component={ <LinkList links={ Categories._3.links } /> } />
        </div>
      </div>
    );
  }
};

export default OurStory;



// WEBPACK FOOTER //
// ./src/routes/OurStory.js